export const ROUTES = {
  home: '/',
  login: '/login',
  competitor: {
    default: '/competitor',
    matchSKU: {
      default: '/competitor/sku',
      detail: (id?: string) => (id ? `/competitor/sku/${id}` : '/competitor/sku'),
    },
    matchStatus: '/competitor/match-status',
  },
  ai: {
    default: '/ai',
    manual: '/ai/manual',
    agentRegistry: '/ai/agent-registry',
  },
  oms: {
    default: '/oms',
    orders: '/oms/orders',
    orderDetail: (id?: string) => (id ? `/oms/orders/${id}` : '/oms/orders'),
    orderAudit: (id: string) => `/oms/orders/${id}/audit`,
    deliveryTrace: (id: string, trackingNo: string) => `/oms/orders/${id}/trace/${trackingNo}`,
    fulfillment: '/oms/fulfillment',
    wms: {
      default: '/oms/wms',
      viewOrders: '/oms/wms/view-orders',
      stock: '/oms/wms/stock',
      readyToBeOutbonded: '/oms/wms/stock/readyToBeOutbonded',
    },
  },
  sourcing: {
    default: '/sourcing',
    matching: '/sourcing/matching',
    matchingWithGlowpickId: (glowpickId?: string) =>
      glowpickId ? `/sourcing/matching/glowpickId/${glowpickId}` : '/sourcing/matching',
    matchingWithBrand: (brand?: string) =>
      brand ? `/sourcing/matching/brand/${encodeURIComponent(brand)}` : '/sourcing/matching',
    matchingWithCategory: (category?: string, subcategory?: string) =>
      category
        ? `/sourcing/matching/category/${encodeURIComponent(category)}${subcategory ? `/subcategory/${encodeURIComponent(subcategory)}` : ''}`
        : '/sourcing/matching',
    matched: '/sourcing/matched',
    matchedWithCategory: (category?: string, subcategory?: string) =>
      category
        ? `/sourcing/matched/category/${encodeURIComponent(category)}${subcategory ? `/subcategory/${encodeURIComponent(subcategory)}` : ''}`
        : '/sourcing/matched',
    matchedGpi: (gpi?: string) => (gpi ? `/sourcing/matched/gpi/${gpi}` : '/sourcing/matched'),
    matchedDetail: (cpProductId?: string, cpItemId?: string) =>
      cpProductId && cpItemId ? `/sourcing/matched/${cpProductId}/${cpItemId}` : '/sourcing/matched',
    matchedImageEditor: (cpProductId?: string, cpItemId?: string, tab?: 'thu' | 'pdp') =>
      cpProductId && cpItemId
        ? `/sourcing/matched/${cpProductId}/${cpItemId}/image-editor${tab ? `/${tab}` : '/thu'}`
        : '/sourcing/matched',
    ssReMatching: '/sourcing/ss-cp-rematching',
    scrapeBatch: '/sourcing/scrape-batch',
  },
  banner: {
    default: '/site-management/banner',
    upload: '/site-management/banner/upload',
    list: '/site-management/banner/list',
  },
  review: {
    default: '/review',
  },
  catalog: {
    default: '/catalog',
    ssEditor: '/catalog/ss-editor',
    ssEditorWithSku: (sku: string) => `/catalog/ss-editor/sku/${sku}`,
    cmWorkflow: '/catalog/cm-workflow',
  },
  siteManagement: {
    default: '/site-management',
    cache: '/site-management/cache',
    campaigns: '/site-management/campaigns',
    shipping: '/site-management/shipping',
  },
  systemManagement: {
    default: '/system-management',
    cronJobs: '/system-management/cron-jobs',
    redirectConfiguration: '/system-management/redirect-configuration',
  },
  category: {
    default: '/category',
    ingredient: {
      default: '/category/ingredient',
    },
  },
  customer: {
    default: '/customer',
    loyalty: '/customer/loyalty',
    tierManagement: '/customer/loyalty/tier-management',
  },
};
